<template>
  <main id="faq-page" class="nuxt-page">
    <!-- Background -->
    <div class="page-bg">
      <div class="page-gradient-1"></div>
      <div class="page-gradient-2"></div>
      <div class="page-grid"></div>
    </div>

    <section class="faq-section">
      <div class="faq-container">
        <!-- Header -->
        <div class="page-header">
          <span class="page-badge">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"/>
              <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
              <line x1="12" y1="17" x2="12.01" y2="17"/>
            </svg>
            Pusat Bantuan
          </span>
          <h1 class="page-title">Pertanyaan yang <span class="text-gradient">Sering Ditanyakan</span></h1>
          <p class="page-subtitle">Temukan jawaban untuk pertanyaan umum seputar layanan Yohom.</p>
        </div>

        <!-- FAQ Cards -->
        <div class="faq-list">
          <div
            v-for="(item, index) in faqItems"
            :key="index"
            class="faq-card"
            :class="{ 'faq-card--active': activeIndex === index }"
            @click="toggleItem(index)"
          >
            <div class="faq-header">
              <div class="faq-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="12" cy="12" r="10"/>
                  <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
                  <line x1="12" y1="17" x2="12.01" y2="17"/>
                </svg>
              </div>
              <h3 class="faq-title">{{ item.question }}</h3>
              <div class="faq-chevron">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="6 9 12 15 18 9"/>
                </svg>
              </div>
            </div>
            <transition name="slide">
              <div class="faq-body" v-if="activeIndex === index">
                <p>{{ item.answer }}</p>
              </div>
            </transition>
          </div>
        </div>

        <!-- Contact CTA -->
        <div class="faq-cta">
          <div class="cta-card">
            <div class="cta-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
              </svg>
            </div>
            <h3 class="cta-title">Masih ada pertanyaan?</h3>
            <p class="cta-desc">Hubungi kami langsung via WhatsApp untuk bantuan lebih lanjut.</p>
            <a href="https://wa.me/6282228502424?&text=Hai Yohom, saya ingin bertanya." target="_blank" class="cta-btn">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
              </svg>
              Hubungi Kami
            </a>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  name: "Faq",
  data() {
    return {
      activeIndex: 0,
      faqItems: [
        {
          question: "Apa itu Yohom?",
          answer: "Yohom adalah platform layanan yang menghubungkan pengguna dengan mitra profesional untuk mengatasi berbagai kebutuhan seperti perbaikan rumah, elektronik, dan layanan darurat.",
        },
        {
          question: "Bagaimana cara memesan layanan?",
          answer: "Anda dapat memesan layanan melalui aplikasi Yohom di smartphone atau menghubungi kami melalui WhatsApp. Pilih jenis layanan, tentukan jadwal, dan mitra kami akan segera menghubungi Anda.",
        },
        {
          question: "Apakah layanan Yohom bergaransi?",
          answer: "Ya, setiap layanan yang disediakan oleh mitra Yohom memiliki garansi. Jika terjadi masalah setelah pekerjaan selesai, Anda dapat menghubungi kami untuk tindak lanjut.",
        },
        {
          question: "Bagaimana cara menjadi mitra Yohom?",
          answer: "Anda dapat mendaftar sebagai mitra Yohom melalui halaman Gabung Mitra di website ini. Isi formulir pendaftaran dan tim kami akan memproses pengajuan Anda.",
        },
        {
          question: "Apakah ada biaya survey?",
          answer: "Ya, terdapat biaya survey yang akan diinformasikan sebelum proses dilakukan. Biaya ini akan menjadi bagian dari total biaya layanan jika Anda melanjutkan pesanan.",
        },
        {
          question: "Area mana saja yang dilayani?",
          answer: "Saat ini Yohom melayani area Kudus dan sekitarnya. Kami terus berupaya memperluas jangkauan layanan ke kota-kota lain di Indonesia.",
        },
      ],
    };
  },
  methods: {
    toggleItem(index) {
      this.activeIndex = this.activeIndex === index ? null : index;
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Public+Sans:wght@400;500;600;700;800&display=swap');

.nuxt-page {
  font-family: 'Public Sans', sans-serif;
  min-height: 100vh;
  background: #fcfcfd;
  position: relative;
  overflow: hidden;
  padding: 100px 16px 60px;
  -webkit-font-smoothing: antialiased;
}

/* Background */
.page-bg {
  position: absolute;
  inset: 0;
  pointer-events: none;
}

.page-gradient-1 {
  position: absolute;
  top: -150px;
  left: -80px;
  width: 500px;
  height: 500px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(168, 85, 247, 0.06) 0%, transparent 70%);
  animation: bgFloat 8s ease-in-out infinite;
}

.page-gradient-2 {
  position: absolute;
  bottom: -100px;
  right: -60px;
  width: 400px;
  height: 400px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(16, 185, 129, 0.06) 0%, transparent 70%);
  animation: bgFloat 10s ease-in-out infinite reverse;
}

.page-grid {
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(rgba(0, 0, 0, 0.02) 1px, transparent 1px),
    linear-gradient(90deg, rgba(0, 0, 0, 0.02) 1px, transparent 1px);
  background-size: 64px 64px;
  mask-image: radial-gradient(ellipse 70% 50% at 50% 30%, black 20%, transparent 100%);
  -webkit-mask-image: radial-gradient(ellipse 70% 50% at 50% 30%, black 20%, transparent 100%);
}

@keyframes bgFloat {
  0%, 100% { transform: translateY(0) scale(1); }
  50% { transform: translateY(-20px) scale(1.03); }
}

/* Container */
.faq-section {
  position: relative;
  z-index: 1;
}

.faq-container {
  max-width: 720px;
  margin: 0 auto;
}

/* Header */
.page-header {
  text-align: center;
  margin-bottom: 48px;
}

.page-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border-radius: 100px;
  background: rgba(168, 85, 247, 0.08);
  color: #7c3aed;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.02em;
  border: 1px solid rgba(168, 85, 247, 0.15);
  margin-bottom: 20px;
}

.page-title {
  font-size: 36px;
  font-weight: 800;
  color: #111827;
  line-height: 1.2;
  letter-spacing: -0.025em;
  margin: 0 0 12px;
}

.text-gradient {
  background: linear-gradient(135deg, #10b981 0%, #059669 50%, #047857 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.page-subtitle {
  font-size: 16px;
  color: #6b7280;
  line-height: 1.6;
  max-width: 480px;
  margin: 0 auto;
}

/* FAQ Cards */
.faq-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.faq-card {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.2s ease;
}

.faq-card:hover {
  border-color: #d1d5db;
}

.faq-card--active {
  border-color: rgba(16, 185, 129, 0.3);
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.06);
}

.faq-header {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 18px 24px;
}

.faq-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  height: 40px;
  border-radius: 10px;
  background: rgba(168, 85, 247, 0.08);
  color: #7c3aed;
  flex-shrink: 0;
  transition: all 0.2s ease;
}

.faq-card--active .faq-icon {
  background: linear-gradient(135deg, #8b5cf6, #7c3aed);
  color: #fff;
}

.faq-title {
  flex: 1;
  font-size: 16px;
  font-weight: 600;
  color: #374151;
  margin: 0;
}

.faq-card--active .faq-title {
  color: #111827;
}

.faq-chevron {
  color: #9ca3af;
  transition: transform 0.2s ease;
  flex-shrink: 0;
}

.faq-card--active .faq-chevron {
  transform: rotate(180deg);
  color: #7c3aed;
}

.faq-body {
  padding: 0 24px 20px 80px;
}

.faq-body p {
  font-size: 15px;
  color: #6b7280;
  line-height: 1.7;
  margin: 0;
}

/* Transitions */
.slide-enter-active,
.slide-leave-active {
  transition: all 0.2s ease;
}

.slide-enter-from,
.slide-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}

/* CTA */
.faq-cta {
  margin-top: 48px;
}

.cta-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 40px 32px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  gap: 12px;
}

.cta-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 16px;
  background: linear-gradient(135deg, rgba(16, 185, 129, 0.1) 0%, rgba(5, 150, 105, 0.1) 100%);
  color: #059669;
  margin-bottom: 4px;
}

.cta-title {
  font-size: 20px;
  font-weight: 700;
  color: #111827;
  margin: 0;
}

.cta-desc {
  font-size: 15px;
  color: #6b7280;
  margin: 0 0 8px;
  max-width: 400px;
}

.cta-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  background: linear-gradient(135deg, #25d366, #128c7e);
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  font-family: 'Public Sans', sans-serif;
  text-decoration: none;
  border-radius: 10px;
  transition: all 0.2s ease;
  box-shadow: 0 2px 8px rgba(37, 211, 102, 0.3);
}

.cta-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(37, 211, 102, 0.4);
}

/* Responsive */
@media (max-width: 640px) {
  .nuxt-page {
    padding: 80px 16px 40px;
  }

  .page-title {
    font-size: 28px;
  }

  .faq-header {
    padding: 14px 18px;
  }

  .faq-body {
    padding-left: 18px;
  }

  .cta-card {
    padding: 32px 24px;
  }
}
</style>